import { invoiceApis } from '@apis/invoiceApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { InvoiceQueryParam } from '@models/Invoice';

export const useInvoiceList = createUseQuery(
  (query: InvoiceQueryParam) => ['/invoice/', query],
  (query) => () =>
    invoiceApis
      .get('/invoice/', {
        query,
      })
      .then((r) => r[200]!),
);
